import { render } from "./WageCalendar.vue?vue&type=template&id=3dc3db1d"
import script from "./WageCalendar.vue?vue&type=script&lang=js"
export * from "./WageCalendar.vue?vue&type=script&lang=js"

import "./WageCalendar.vue?vue&type=style&index=0&id=3dc3db1d&lang=css"

import exportComponent from "C:\\Users\\chany\\Desktop\\my\\apache\\project\\vue_wage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__